<rt-admins-select-dialog-form
  [heading]="heading"
  [subheading]="subheading"
  [assignments]="assignments"
  [lockedAssignments]="lockedAssignments"
  [lockedAssignmentsTooltip]="lockedAssignmentsTooltip"
  [preventAdminRemove]="preventAdminRemove"
  [admins]="allowedUsers"
  [disallowedUsers]="disallowedUsers"
  [currentAdminId]="currentAdminId"
  [showCountBeforeSubheading]="showCountBeforeSubheading"
  [minSelectedAdmins]="minSelectedAdmins"
  [maxSelectedAdmins]="maxSelectedAdmins"
  [inviteModeEnabled]="inviteModeEnabled"
  [disabledUserCopy]="disabledUserCopy"
  [disabledUsersHeader]="disabledUsersHeader"
  [actionLabel]="actionLabel"
  [hasActionLabelCount]="hasActionLabelCount"
  [additionalUserSelectionOptions]="additionalUserSelectionOptions"
  [withInviteTeamMembersButton]="withInviteTeamMembersButton"
  [hasStepBack]="hasStepBack"
  [stepText]="stepText"
  (selectAllClick)="selectAdminsAnalytics.selectAll()"
  (selectNoneClick)="selectAdminsAnalytics.selectNone()"
  (cancelClick)="cancel()"
  (submitClick)="submit($event)"
  (backClick)="goBack($event)"
  (inviteTeamMembersClick)="redirectToInvitingMembers()"
/>
